import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { css } from "@emotion/react";
import { fontSize, colors, margins } from "style";

/**
 * Signup Complete Message
 *
 * @params {Object}   formData
 */
const SignupComplete = ({ formData, ...props }) => (
  <div {...props} css={styles.container}>
    <div css={styles.title}>
      <FormattedMessage id="Signup.SignupComplete.Title" />
    </div>
    <div css={styles.body}>
      <FormattedMessage id="Signup.SignupComplete.Body" values={{ name: formData?.firstName }} />
    </div>
  </div>
);

const styles = {
  container: css`
    margin-left: ${margins.normal};
  `,
  title: css`
    font-size: ${fontSize.xxlarge};
    font-weight: 700;
  `,
  body: css`
    margin-top: 1rem;
    font-size: ${fontSize.medium};
    color: ${colors.grayAnatomyLight1};
    line-height: 1.5;
  `,
};

SignupComplete.propTypes = {
  formData: PropTypes.object.isRequired,
};

export default SignupComplete;
